var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "storefinder" },
    [
      _c(
        "section",
        {
          ref: "resultSection",
          staticClass: "contentWrapper storefinder__resultSection",
        },
        [
          _vm.stores.length
            ? _c(
                "article",
                {
                  staticClass:
                    "offsetLeft-noOuterGap--1 offsetRight-noOuterGap--1 storefinder__resultListWrapper",
                },
                [
                  _c(
                    "header",
                    {
                      staticClass: "headline--3 storefinder__resultListHeader",
                    },
                    [_vm._v(_vm._s(_vm.defaultResultListTitle))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "storefinder__resultList" },
                    _vm._l(_vm.storesArray, function (store, key) {
                      return _c("StorefinderResult", {
                        key: key,
                        staticClass: "storefinder__resultList__result",
                        attrs: {
                          store: store,
                          "static-text-phone": _vm.staticTextPhone,
                          "static-text-web": _vm.staticTextWeb,
                          "static-text-email": _vm.staticTextEmail,
                          "static-text-directions": _vm.staticTextDirections,
                          "static-text-contact-button":
                            _vm.staticTextContactButton,
                        },
                        on: { contact: _vm.onContact },
                      })
                    }),
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("StorefinderContactDialog", {
        ref: "contactDialog",
        attrs: {
          contact: _vm.selectedContact,
          contactModalTitle: _vm.contactModalTitle,
          contactMessageLabel: _vm.contactMessageLabel,
          contactMessagePrefix: _vm.contactMessagePrefix,
          contactMessageSuffix: _vm.contactMessageSuffix,
          staticTextFormSalutation: _vm.staticTextFormSalutation,
          staticTextFormSalutationMister: _vm.staticTextFormSalutationMister,
          staticTextFormSalutationMisses: _vm.staticTextFormSalutationMisses,
          staticTextFormName: _vm.staticTextFormName,
          staticTextFormStreetNumber: _vm.staticTextFormStreetNumber,
          staticTextFormZipCode: _vm.staticTextFormZipCode,
          staticTextFormPhone: _vm.staticTextFormPhone,
          staticTextFormEmail: _vm.staticTextFormEmail,
          staticTextFormDataprotection: _vm.staticTextFormDataprotection,
          staticTextFormSubmit: _vm.staticTextFormSubmit,
          staticTextFormSuccess: _vm.staticTextFormSuccess,
          staticTextFormError: _vm.staticTextFormError,
        },
        scopedSlots: _vm._u([
          {
            key: "modal-close-text",
            fn: function () {
              return [_vm._v(_vm._s(_vm.staticTextCloseWindow))]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }